// extracted by mini-css-extract-plugin
export default {"s-container":"Contactus_s-container__jGhw-","s-mail":"Contactus_s-mail__VLnUs","s-note":"Contactus_s-note__Kr1I8"};